var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "mx-auto card-option fill-height pull-up",
      attrs: { "max-width": "300" },
      on: { click: _vm.click }
    },
    [
      _c("v-img", {
        staticClass: "white--text align-end",
        attrs: { height: "165px", src: _vm.image }
      }),
      _c("v-card-title", { staticClass: "pb-0" }, [_vm._t("title")], 2),
      _c(
        "v-card-text",
        { staticClass: "text--primary" },
        [_vm._t("content")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }